import { useEffect, useState } from 'react'
import { api, ApiError } from '@orisini/ui/lib/api'

interface HealthResponse {
  ok: boolean
  service: string
  db: 'ok' | 'error'
  dbError?: string
  latencyMs: number
  time: string
}

/**
 * Halaman diagnostik Phase 0: memastikan SPA tersaji dan Worker + D1 hidup.
 * Nanti diganti Dashboard asli, tapi tetap berguna sebagai smoke test deploy.
 */
export default function HealthPage() {
  const [state, setState] = useState<
    { status: 'loading' } | { status: 'ok'; data: HealthResponse } | { status: 'error'; message: string }
  >({ status: 'loading' })

  useEffect(() => {
    api
      .get<HealthResponse>('/health')
      .then((data) => setState({ status: 'ok', data }))
      .catch((err: unknown) =>
        setState({
          status: 'error',
          message: err instanceof ApiError ? `${err.code}: ${err.message}` : String(err),
        }),
      )
  }, [])

  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center gap-6 p-8">
      <header>
        <h1 className="text-3xl font-semibold tracking-tight">Gramium</h1>
        <p className="text-sm text-muted-foreground">Instagram post scheduler</p>
      </header>

      <section className="rounded-lg border bg-card p-5">
        <h2 className="mb-3 text-sm font-medium uppercase tracking-wide text-muted-foreground">
          Backend status
        </h2>

        {state.status === 'loading' && <p className="text-sm">Contacting the Worker…</p>}

        {state.status === 'error' && (
          <p className="text-sm text-destructive">Couldn't reach the API — {state.message}</p>
        )}

        {state.status === 'ok' && (
          <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
            <dt className="text-muted-foreground">Worker</dt>
            <dd className="font-medium text-emerald-500">up</dd>

            <dt className="text-muted-foreground">D1</dt>
            <dd className={state.data.db === 'ok' ? 'font-medium text-emerald-500' : 'font-medium text-destructive'}>
              {state.data.db === 'ok' ? 'connected' : `error — ${state.data.dbError}`}
            </dd>

            <dt className="text-muted-foreground">Latency</dt>
            <dd className="font-medium">{state.data.latencyMs} ms</dd>

            <dt className="text-muted-foreground">Server time</dt>
            <dd className="font-medium tabular-nums">{state.data.time}</dd>
          </dl>
        )}
      </section>
    </main>
  )
}
